import React, { Component } from "react";
import { Segment, Button, Input } from "semantic-ui-react";
import uuidv4 from "uuid/v4";
import { MyStore } from "../../../../services/Store";
import FileModal from "./FileModal";
import UploadBar from "./UploadBar";


import firebase from "firebase/app";
import "firebase/functions";
import 'firebase/database';

import 'firebase/storage';


class MessageForm extends Component {
    constructor(props) {
        super(props)
        this.groups= [];
        this.users = [];
        this.state = {
            isDM: false,
            uploadState: "",
            uploadTask: null,
            percentUploaded: 0,
            storageRef: MyStore.storage().ref(),
            currentGroup: this.props.currentGroup, 
            // currentGroup: '',
            // currentUser: [],
            // groupsRef: '',
            // dmRef: MyStore.database().ref().child("directMessages"),
            dmRef: '',

    
            currentUser: this.props.currentUser,
            // groupsRef: MyStore.database().ref().child("groups"),
            groupsRef: firebase.database().ref("groups"),
            users:'',
            databaseRef: MyStore.database().ref(),
            message: "",
            loading: false,
            errors: [],
            modal: false,
            userId: "",
            username: "",
            photoURL: "",
            user: '',
        }
    
    }
    
    // state = {
    //     isDM: false,
    //     uploadState: "",
    //     uploadTask: null,
    //     percentUploaded: 0,
    //     storageRef: MyStore.storage().ref(),
    //     // currentGroup: this.props.currentGroup,
    //     currentGroup: '',
    //     currentUser: [],
    //     groupsRef: '',
    //     // dmRef: MyStore.database().ref().child("directMessages"),
    //     dmRef: '',

    //     databaseRef: MyStore.database().ref(),
    //     message: "",
    //     loading: false,
    //     errors: [],
    //     modal: false,
    //     groups: [],
    //     userId: "",
    //     username: "",
    //     photoURL: "",
    //     user: '',
    // };



    // -LwLoqhrvooVCR3mC2Rb

    static getDerivedStateFromProps(nextProps) {
        return {
            currentGroup: nextProps.currentGroup,
            currentUser: nextProps.currentUser,
            isDM: nextProps.isDM
        };
    }



    // message: "",
    // loading: false,
    // errors: [],
    // modal: false,
    // userId: "",
    // username: "",
    // photoURL: "",
    // user: '',


    componentDidMount() {
        // console.log(this.props)

        let { isDM, groupsRef, dmRef, currentGroup, meesage, userId, username, user, photoURL, users } = this.state;

        // console.log('--------- groupsRef ------------')
        // console.log(groupsRef)

        // storageRef: MyStore.storage().ref(),
        // // currentGroup: this.props.currentGroup,
        // currentGroup: MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ"),
        // currentUser: this.props.currentUser,
        // groupsRef: MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ"),
        // dmRef: MyStore.database().ref("directMessages"),



        // this.state.currentGroup =MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ")

        // this.state.currentUser = MyStore.auth().currentUser
        // isDM = false

        this.setState({isDm: false})
        


        // console.log( this.state.currentUser.uid)
        // uid: userId,
        // username: currentUser.displayName,
        // avatar: currentUser.photoURL

        
// --------------------------------------

        // let a_dmRef = MyStore.database().ref().child("directMessages").child("-LwLokoEOlo2jFZHUsDJ")
        let a_dmRef =  this.state.databaseRef.child("directMessages").child("-LwLokoEOlo2jFZHUsDJ")
        // console.log(a_dmRef)
 
        dmRef = MyStore.database().ref().child("directMessages")
        // this.setState({dmRef:  MyStore.database().ref().child("directMessages")})
        // this.state.dmRef =  MyStore.database().ref().child("directMessages")

        
        // console.log('current dmRef----- line 47')
        // console.log(dmRef)
        // console.log(dmRef.child("-LwLokoEOlo2jFZHUsDJ"))
        
        
// --------------------------------------

        // groupsRef = this.state.databaseRef.child("groups")
        
        // this.setState({groupsRef:groupsRef})
        // console.log('--------- comp did mount ------------')
        // console.log(groupsRef)

        // this.state.user = MyStore.auth().currentUser;
        this.state.userId = this.state.user.uid
        // console.log( this.state.user.uid)



        // ref.child('users').orderByChild('name').equalTo('John Doe')
        // this.state.currentUser = MyStore.database().ref().child("groups").orderByChild("-LwLokoEOlo2jFZHUsDJ").equalTo( this.state.user.uid)

        // MyStore.database().ref().child("usernames").on('value', (snap) => console.log(snap.val()))


        MyStore.auth().onAuthStateChanged((user) => {
            if (user) {
                this.state.databaseRef.child("usernames").on('value', snap => {
                    // console.log(snap.val())
                    let myArr = []
                    // console.log('----------- function 02 -------------')
                    for (const key in snap.val()) {
                        myArr.push(Object.assign({}, snap.val()[key]));
                    }
                    if (snap.val() != null) {
                        // users = myArr
                        this.setState({
                            users: myArr
                        })
                    }
                    // else {
                    //   this.setState({
                    //     groups: []
                    //   })    
                    // }

                });

            }

        })

        // console.log(this.users)



//         MyStore.auth().onAuthStateChanged((user) => {
//             if (user) {
//                 console.log(user)
//                 this.state.userId = user.uid
//                 console.log( this.state.user.uid)

//         this.state.database().ref().child("usernames").on('value', function(snapshot) {
//             console.log(snapshot.val());
//             const current = []
//             // snapshot.forEach(function(data) {

//             //     console.log(data);
//             // });
//             for (const key in snapshot.val()) {

//                 console.log(snapshot.val()[key]);
//                 console.log(snapshot.val()[key].uid);
//                 if (snapshot.val()[key].uid ===  'iTWKSQNQ4GcUlqZ22WXA5QplHsj1' ){
//                     current.push(Object.assign({}, snapshot.val()[key]));
//                     break
//                 }
//                 if (snapshot.val() != null) {
//                     this.setState({
//                         currentUser : current
//                     })
//                 }
//                 // myArr.push(Object.assign({}, snap.val()[key]));
//             }
//             //  this.setState({currentUser:current})
//             console.log(current)
//             // this.state.currentUser = current
//         });
//     }
// })

        // console.log('---- current user ------')
        // console.log(this.state.currentUser)

        // MyStore.database().ref().child("usernames").orderByChild("usernames").equalTo( this.state.user.uid).on("value", function(snapshot) {
        //     console.log(snapshot.val());
        //     snapshot.forEach(function(data) {
        //         console.log(data.key);
        //     });
        // });


        // MyStore.database().ref().child("groups").orderByChild("-LwLokoEOlo2jFZHUsDJ").equalTo( this.state.user.uid).on("value", function(snapshot) {
        //     console.log(snapshot.val());
        //     snapshot.forEach(function(data) {
        //         console.log(data.key);
        //     });
        // });



        // console.log(  MyStore.database().ref().child("groups"))
        // console.log(  this.state.databaseRef.child("groups"))message




        // currentGroup = MyStore.database().ref().child("groups").child("-LwLokoEOlo2jFZHUsDJ")

        // console.log(this.state.currentGroup)

        // let usernames = MyStore.database().ref().child("usernames").value(this.state.userId )

        // console.log(this.state.currentUser)

        // this.state.userId = this.state.currentUser.uid

        // this.state.username =  this.state.currentUser.username
        // this.state.avatar = this.state.currentUser.avatar

        // console.log( this.state.userId )
        // console.log(this.state.username)
        // console.log( this.state.avatar )




        // this.state.databaseRef.child("groups").child("-LwLoSp4EsH68gJO4mEM").then((metadata) => {

        //     console.log('-------- currentGroup -----------')
        //     console.log(metadata)
        // })

        // MyStore.auth().onAuthStateChanged((user) => {
        //     if (user) {
        //         this.state.databaseRef.child("groups").on('value', snap => {
        //             console.log(snap.val())
        //             let myArr = []
        //             console.log('----------- function 02 -------------')
        //             for (const key in snap.val()) {
        //                 myArr.push(Object.assign({}, snap.val()[key]));
        //             }
        //             if (snap.val() != null) {
        //                 this.groups = myArr
           
        //             }
          

        //         });





        //     }


        // })

        // console.log('-------- currentGroup -----------')
        // console.log(this.groups)
        // console.log(this.state.currentGroup.child("groups").child("-LwLoSp4EsH68gJO4mEM"))


    }


    openModal = () => {
        this.setState({ modal: true });
    };

    closeModal = () => {
        this.setState({ modal: false });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleUploadError = error => {
        console.error(error);
        this.setState({
            errors: this.state.errors.concat(error),
            uploadState: "error",
            uploadTask: null
        });
    };

    getMessagesRef = () => {
        const { isDM, groupsRef, dmRef, currentGroup } = this.state;
        // console.log('---- currentGroup ------')
        // console.log(currentGroup)
        // console.log(currentGroup.id)

        // console.log(groupsRef)
        
        if (isDM) {
            return dmRef.child(currentGroup.id).child("messages");
        } else {
            // return groupsRef.child(currentGroup.id).child("messages");
            return groupsRef.child(this.props.oid).child("chats").child(this.props.currentGroup.logsGroupId);
        }

        // console.log('------------ groupsRef -------------')
        // console.log(groupsRef)

        // const groupId = '-LwLokoEOlo2jFZHUsDJ'
        const groupId = "-LwLokoEOlo2jFZHUsDJ"
        // const groupId  = '-LwLoqhrvooVCR3mC2Rb'

        // if (isDM) {
        //     return dmRef.child(currentGroup.id).child("messages");
        // } else {
        //     return groupsRef.child(currentGroup.id).child("messages");
        // }

        // 'directMessages.-LwLokoEOlo2jFZHUsDJ.messages.-LwWZsUDa2ElDn5VzFMe.author.username'
        // 'groups.-LwLokoEOlo2jFZHUsDJ.messages.-LwW_yRZFkr3c4bdfgrx.author.username'
        // if (isDM) {
        //     return dmRef.child(groupId).child("messages");
        // } else {
        //     return groupsRef.child(groupId).child("messages");
        // }

        // return groupsRef.child(groupId).child("messages")
        // return groupsRef.child(currentGroup.key).child("messages");
        


    };



    uploadFile = (file, metadata) => {
        // console.log(file);
        // console.log(metadata);

        const { currentGroup, storageRef, isDM } = this.state;

        const messagesRef = this.getMessagesRef();
        const groupId = '-LwLokoEOlo2jFZHUsDJ'

        // const filePath = `${isDM ? "directMessages" : "group"}/${
        //     currentGroup.id
        // }/${uuidv4()}.${metadata.extension}`;


        const filePath = `${isDM ? "directMessages" : "group"}/${
            groupId
            }/${uuidv4()}.${metadata.extension}`;

        // console.log(filePath);

        this.setState(
            {
                uploadState: "uploading",
                uploadTask: storageRef.child(filePath).put(file, metadata)
            },
            () => {
                this.state.uploadTask.on(
                    "state_changed",
                    snap => {
                        let percentUploaded = Math.round(
                            (snap.bytesTransferred / snap.totalBytes) * 100
                        );
                        this.setState({ percentUploaded });
                    },
                    error => {
                        this.handleUploadError(error);
                    },
                    () => {
                        this.state.uploadTask.snapshot.ref
                            .getDownloadURL()
                            .then(downloadURL => {
                                this.sendFileMessage(
                                    downloadURL,
                                    file.name,
                                    metadata,
                                    messagesRef
                                );
                            })
                            .catch(error => {
                                this.handleUploadError(error);
                            });
                    }
                );
            }
        );
    };

    createMessage = (fileURL = null, fileName = null, metadata = null) => {
        const { message, currentUser, userId, username, photoURL } = this.state;
        // console.log('userid username photourl ')
        // console.log(this.state)

        const messagesRef = this.getMessagesRef();

        // console.log('message line 452')
        // console.log(messagesRef)

        const messageId = messagesRef.push().key;

        const newMessage = {
            id: messageId,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
            text: message,
        author: {
                    uid: currentUser.uid,
                    username: currentUser.displayName,
                    avatar: currentUser.photoURL
                }
        };

        // console.log('---------- newMessage --------------')
        // console.log(newMessage)


        if (fileURL && fileName && metadata) {
            if (
                metadata.contentType === "image/jpeg" ||
                metadata.contentType === "image/png"
            ) {
                newMessage["imageURL"] = fileURL;
            } else {
                newMessage["fileURL"] = fileURL;
            }
            newMessage["fileName"] = fileName;
        }
        return newMessage;
    };

    sendFileMessage = (fileURL, fileName, metadata, messagesRef) => {
        const { errors } = this.state;
        const newMessage = this.createMessage(fileURL, fileName, metadata);

        messagesRef
            .child(newMessage.id)
            .update(newMessage)
            .then(() => {
                this.setState({
                    uploadState: "",
                    uploadTask: null,
                    percentUploaded: 0,
                    message: "",
                    loading: false,
                    errors: []
                });
            })
            .catch(error => {
                console.error(error);
                this.setState({
                    loading: false,
                    errors: errors.concat(error)
                });
            });
    };

    sendMessage = () => {
        const { message, errors } = this.state;

        const messagesRef = this.getMessagesRef();

        if (message) {
            this.setState({ loading: true });
            const newMessage = this.createMessage();
            messagesRef
                .child(newMessage.id)
                .update(newMessage)
                .then(() => {
                    this.setState({
                        message: "",
                        loading: false,
                        errors: []
                    });
                })
                .catch(error => {
                    console.error(error);
                    this.setState({
                        loading: false,
                        errors: errors.concat(error)
                    });
                });
        } else {
            this.setState({
                errors: errors.concat({ message: "Message cannot be empty" })
            });
        }
    };

    render() {
        const {
            loading,
            message,
            errors,
            modal,
            percentUploaded,
            uploadState
        } = this.state;

        return (
            <Segment id="message__form" >
                <Input
         
                    fluid
                    id="message__input"
                    name="message"
                    style={{ marginBottom: "0.7em" }}
                    label={<Button icon={"keyboard"} />}
                    labelPosition="left"
                    placeholder="Write a message"
                    onChange={this.handleChange}
                    value={message}
                    disabled={loading || uploadState === "uploading"}
                    className={errors.length > 0 ? "error" : ""}

                    type="text" onKeyPress={e => {
                        if (e.key === 'Enter') e.preventDefault();
                      }}
                    
                />
                <Button.Group icon widths="2">
                    <Button
                        className={uploadState === "uploading" ? "loading" : ""}
                        inverted color="blue"
                        content="Send"
                        labelPosition="right"
                        icon="reply"
                        onClick={this.sendMessage}
                        disabled={loading || uploadState === "uploading"}
                        style={{ opacity: "1.0" }}
                    />
                    {/* <Button
                        className={uploadState === "uploading" ? "loading" : ""}
                        color="teal"
                        content="Attach"
                        labelPosition="right"
                        icon="folder open"
                        onClick={this.openModal}
                        disabled={loading || uploadState === "uploading"}
                        style={{ opacity: "0.75" }}
                    /> */}
                </Button.Group>
                {/* <FileModal
                    modal={modal}
                    closeModal={this.closeModal}
                    uploadFile={this.uploadFile}
                /> */}
                <UploadBar
                    percentUploaded={percentUploaded}
                    uploadState={uploadState}
                />
            </Segment>
        );
    }
}

export default MessageForm;
